import { GET_ISSUE_LOG, GET_ISSUE_LOG_SUCCESS, GET_ISSUE_LOG_ERROR, GET_ISSUE_LOG_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetIssueLog = (state = initialState, action) => {
  switch (action.type) {
    case GET_ISSUE_LOG:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_ISSUE_LOG_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_ISSUE_LOG_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_ISSUE_LOG_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetIssueLog;
